module.exports = __webpack_public_path__ + "img/refresh.6073af75.svg";